import { useState } from 'react';
import AsyncSelect from 'react-select/async';
import { cachedFetch } from '../../utils/cached-api-wrapper';
import { getSelectStyles } from '../../utils/utils';

// Reuse the same tenant-scoped catalogs as the full invoice editor. A catalog
// failure stays visible instead of being presented as an empty search result.
export default function InvoiceLookup({ id, url, value, onChange, portal, disabled, t }) {
  const [failed, setFailed] = useState(false);
  const load = (text, callback) => {
    // Callback mode: returning cachedFetch's completion promise clears the options.
    cachedFetch(`${url}?text=${encodeURIComponent(text)}`, 'GET', {}, response => {
    setFailed(false);
    callback((Array.isArray(response?.data) ? response.data : []).map(row => ({
      label: [row.name, row.description || row.number].filter(Boolean).join(' · '), value: row,
    })));
  }, () => { setFailed(true); callback([]); });
  };
  return <>
    <AsyncSelect inputId={id} value={value} onChange={option => onChange(option?.value || null)}
      loadOptions={load} defaultOptions isClearable isDisabled={disabled} classNamePrefix='select'
      styles={getSelectStyles(false, false)} menuPortalTarget={portal} menuPosition='fixed'
      placeholder={t.read('review_invoice.search')} noOptionsMessage={() => t.read('review_invoice.no_options')} />
    {failed && <small role='alert' className='text-danger'>{t.read('review_invoice.errors.lookup')}</small>}
  </>;
}
